import React from 'react';
import { Button } from './ui/button';
import { Shuffle, Trash2 } from 'lucide-react';

interface RandomCompaniesHeaderProps {
  hasCompanies: boolean;
  onClearAll: () => void;
}

export const RandomCompaniesHeader: React.FC<RandomCompaniesHeaderProps> = ({
  hasCompanies,
  onClearAll
}) => {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-2">
        <Shuffle className="h-5 w-5 text-indigo-400" />
      </div>
      {hasCompanies && (
        <Button
          onClick={onClearAll}
          variant="ghost"
          size="sm"
          className="text-slate-400 hover:text-white hover:bg-slate-700"
        >
          <Trash2 className="w-4 h-4 mr-1" />
          Clear All
        </Button>
      )}
    </div>
  );
}; 